import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
  selector: 'branch-list',
  templateUrl: './branch-list.component.html',
  styleUrls: ['./branch-list.component.scss']
})


export class BranchListComponent extends BasePage2<Branch> {


  showInMap             : boolean = false;

  branchs               : Branch[] = [];
  branchsByCityId       : Branch[];
  
  code      : string;


  address1 : string;
  address2 : string;
  latitude : number;
  longitude : number;
  isSearchForm = true;

  id : number;
  codeOpening : string;

  constructor(
    protected toastr            : ToastrService,
    protected controlTablesService  : ControlTablesService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) {
   
       super(toastr, router, baseService, leanUtilsService, location);

       this.entityName = 'branch';
  }



//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
  this.baseService.fieldsGet('productCategoryType').then(result => {
        this.childFields = result.listFields;
        this.readOnly    = result.readOnly;
  }) 
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): Branch[] {
    return this.branchs;
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
  let branch : Branch = new Branch();
  branch.inserted = true;
  branch.edit = true;
  this.selectedRow = branch;
}  
//----------------------------------------------------------------------

//----------------------------------------------------------------------
  loadData() {
    this.controlTablesService.branchsGet(this.code).then(result => {
      this.branchs = result;
      this.buildPoints();
      this.isSearchForm = false;
    })
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
selectRow(branch : Branch){
  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = branch.branchCode;

  this.selectedRow = branch;
 // this.controlTablesService.getSingle(this.entityName, request).then(result => {
 //     this.selectedRow = result;
 // })
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
map(show : boolean){
    if (show){
   //   this.buildPoints();
    }
    this.showInMap = show;
  }

  points : marker[] = [];
  buildPoints(){
  //  this.pointEs : Marker[this.branchs.length];
    let i : number = 0;
    if(this.branchs){
      this.branchs.forEach(branch => {

      let point : marker = {     
        lat: branch.latitude,
        lng: branch.longitude,
        label: branch.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    })
  }
}
//----------------------------------------------------------------------

}
